import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const EditCompetitiveSubject = () => {
  const [subjectName, setSubjectName] = useState("");
  const [examCategories, setExamCategories] = useState([]);
  const [examCategoryId, setExamCategoryId] = useState("");
  const [icon, setIcon] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/competitions`)
      .then((response) => setExamCategories(response.data?.data || []))
      .catch((error) => console.log(error));

    axios
      .get(`${API_BASE_URL}/subjects/${id}`)
      .then((response) => {
        const subjectData = response.data?.data;
        setSubjectName(subjectData?.subjectName || "");
        setExamCategoryId(subjectData?.reference || "");
      })
      .catch((error) => console.log(error));
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("subjectName", subjectName);
    formData.append("reference", examCategoryId);
    if (icon) formData.append("icon", icon);

    axios
      .put(`${API_BASE_URL}/subjects/${id}`, formData)
      .then(() => {
        alert("Subject updated successfully");
        navigate("/ce-all-subject");
      })
      .catch((error) => {
        console.log(error);
        alert("Failed to update subject.");
      });
  };

  return (
    <div className="competitive-subject-wrapper">
      <div className="competitive-subject-header-container">
        <h5>Edit Competitive Exam Subject</h5>
        <div className="competitive-subject-form-container">
          <form onSubmit={handleSubmit} className="add-exam-category-form">
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Select Exam Category</label>
              <select
                className="new-chapter-dropdown"
                value={examCategoryId}
                onChange={(e) => setExamCategoryId(e.target.value)}
                required
              >
                <option value="">-Select Exam Category-</option>
                {examCategories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.examCategory}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Subject Name</label>
              <input
                type="text"
                value={subjectName}
                onChange={(e) => setSubjectName(e.target.value)}
                placeholder="Enter Subject Name"
                required
              />
            </div>

            <div className="input-group">
              <label className="label">Upload Icon</label>
              <input
                type="file"
                id="subject-upload-icon"
                onChange={(e) => setIcon(e.target.files[0])}
                accept="image/*"
              />
            </div>

            <div className="add-exam-category-exam-form-buttons">
              <button type="submit" className="add-exam-category-btn-submit">
                Save
              </button>
              <button
                type="button"
                className="add-exam-category-btn-cancel"
                onClick={() => navigate("/ce-all-subject")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCompetitiveSubject;
